<template lang="html">
    <div>
        <b-breadcrumb v-if="this.$auth.check(['root'])">
            <b-breadcrumb-item :to="{ name: 'Ivr' }">Ivr</b-breadcrumb-item>
            <b-breadcrumb-item :to="{ name: 'Polls' }">Encuesta</b-breadcrumb-item>
            <b-breadcrumb-item v-if="$route.name !== 'Poll'">{{ $route.meta.title }}</b-breadcrumb-item>
        </b-breadcrumb>
        <b-breadcrumb v-if="this.$auth.check(['admin'])">
            <b-breadcrumb-item :to="{ name: 'Ivr' }">Ivr</b-breadcrumb-item>
            <b-breadcrumb-item :to="{ name: 'Polls' }">Encuesta</b-breadcrumb-item>
        </b-breadcrumb>
        <data-table v-if="this.$auth.check(['root'])" url="ivr/poll" model="Poll" :fields="fields"  action-buttons primary-key="uuid" no-modal></data-table>
        <poll-show v-if="poll.uuid && this.$auth.check(['admin'])" :poll="poll"></poll-show>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'IndexPoll',
        data() {
            return {
                fields: [
                    { field: 'name', label: 'Nombre', sort: true, hasFilter: false, filter: '', filterAdd: null  },
                ],
                poll: {}
            }
        },
        mounted() {
            this.prepareComponent();
        },
        computed: {
         
        },
        methods: {
            prepareComponent(){
                this.$http.get(`/ivr/poll/`)
                    .then(res =>{
                        this.poll = res.data
                    });
            },
        }
    }
</script>

<style lang="css">
</style>
